import { render } from "./Scorpio.vue?vue&type=template&id=2443d398&scoped=true"
import script from "./Scorpio.vue?vue&type=script&lang=js"
export * from "./Scorpio.vue?vue&type=script&lang=js"

import "./Scorpio.vue?vue&type=style&index=0&id=2443d398&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2443d398"]])

export default __exports__